import React from "react";
// import { useDispatch } from "react-redux";
// import { RootState } from "../../store/store";
// import {
//   changeCurrentMemberMenu,
//   screenChange
// } from "../../store/screenSlice";

// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { createTheme, 
//   ThemeProvider 
// } from "@mui/material/styles";
// import { TextField } from "@mui/material";
// import {
//   updateEvent,
//   deleteCostInfo,
//   deleteLocationInfo,
// } from "../../store/eventApiSlice";
// import { DevTool } from "@hookform/devtools";
// import CurrencyInput from "react-currency-input-field";
// import deleteIcon from "./../../Images/Delete.png";
// import {
//   useForm,
//   Controller,
//   useFormContext,
//   Merge,
//   FieldError,
//   FieldErrorsImpl,
// } from "react-hook-form";
// import { Button, PageLink } from "../StyledComp/StyledComp";
// import { DateValidationError } from "@mui/x-date-pickers";
// import dayjs, { Dayjs } from "dayjs";
// import { all } from "axios";
// import { invalid } from "moment";
// import ReactModal from "react-modal";
// import MemberServices from "../../services/MemberServices";
// import EventServices from "../../services/EventServices";
// import { screenConfig } from "../../config/screenConfig";

const EditOrder: React.FC = () => {
  // const dispatch = useDispatch();
  // dispatch(screenChange("Events"));

  // const muiTextFieldTheme
  // const color1 = "#2d6289";
  // const muiDatePickerColorTheme = (theme: any) =>
  //   createTheme({
  //     ...theme,
  //     palette: {
  //       primary: {
  //         main: color1,
  //       },
  //       secondary: {
  //         main: color1,
  //       },
  //       // error: {
  //       //   main: color1,
  //       // },
  //     },
  //     components: {
  //       MuiIconButton: {
  //         styleOverrides: {
  //           sizeMedium: {
  //             color1,
  //           },
  //         },
  //       },
  //       MuiOutlinedInput: {
  //         styleOverrides: {
  //           root: {
  //             borderRadius: 0,
  //           },
  //           notchedOutline: {
  //             borderWidth: 0,
  //             // borderBottomStyle: "solid",
  //             // borderBottomWidth: 1,
  //             boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
  //           },
  //           input: {
  //             height: "0.8rem",
  //             background: "var(--form-input-background-color)",
  //             paddingTop: "20px",
  //             paddingBottom: "10px",
  //             paddingLeft: "10px",
  //             paddingRight: "0px",
  //             fontWeight: "500",
  //           },
  //         },
  //       },
  //       MuiDatePicker: {
  //         styleOverrides: {
  //           root: {
  //             margin: "normal",
  //           },
  //         },
  //       },
  //       MuiInputLabel: {
  //         styleOverrides: {
  //           root: {
  //             color: color1,
  //             zIndex: 1,
  //           },
  //         },
  //       },
  //       MuiFormLabel: {
  //         styleOverrides: {
  //           root: {
  //             fontWeight: 400,
  //             color: color1,
  //           },
  //         },
  //       },
  //       MuiInputBase: {
  //         styleOverrides: {
  //           root: {
  //             background: "var(--form-input-background-color)",
  //           },
  //         },
  //       },
  //       MuiTextField: {
  //         styleOverrides: {
  //           root: {
  //             // marginBottom: "1.8rem",
  //           },
  //         },
  //       },
  //     },
  //   });

  return (
    <div
      className="dashboard-content-wrapper"
      style={{ marginBottom: "100px" }}
    >
      Edit Order
    </div>
  );
};

export default EditOrder;
